<template>
  <div class="container_self">
    <el-row class="table_parent">
      <el-row class="search_parent">
        <el-row style="margin-bottom: 15px"
          ><el-button type="danger" size="mini" icon="el-icon-plus" @click="handleAdd"
            >添加事件名称</el-button
          ></el-row
        >
        <el-form :model="searchForm" :inline="true" size="mini">
          <el-form-item label="客户名称">
            <el-input
              v-model="searchForm.customerName"
              clearable
              placeholder="请输入客户名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="App名称">
            <el-input
              v-model="searchForm.appName"
              clearable
              placeholder="请输入App名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="设备ID">
            <el-input
              v-model="searchForm.deviceId"
              clearable
              placeholder="请输入渠道名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="渠道">
            <el-input
              v-model="searchForm.channel"
              clearable
              placeholder="请输入渠道名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="Label">
            <el-input
              v-model="searchForm.label"
              clearable
              placeholder="请输入label"
            ></el-input>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker
              v-model="searchForm.start"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              v-model="searchForm.end"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="事件名称">
            <el-select v-model="searchForm.name" clearable placeholder="请选择事件名称">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.description"
                :value="item.name"
              >
              </el-option>
            </el-select>
            <el-button type="warning" icon="el-icon-search" @click="search"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </el-row>

      <h3>事件列表</h3>
      <el-table
        :data="tableData"
        v-loading="loading"
        element-loading-text="加载中，请稍后"
        style="width: 100%"
      >
        <el-table-column align="center" prop="customerName" label="所属客户">
        </el-table-column>
        <el-table-column prop="appName" align="center" label="所属app"> </el-table-column>
        <el-table-column prop="packageName" align="center" label="应用包名">
        </el-table-column>
        <el-table-column align="center" label="设备ID">
          <template slot-scope="scope">
            <span>{{ scope.row.data.deviceId }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="渠道">
          <template slot-scope="scope">
            <span>{{ scope.row.data.channel }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Label">
          <template slot-scope="scope">
            <span>{{ scope.row.data.label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="事件名称"> </el-table-column>
        <el-table-column align="center" label="事件数据">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.data }}</span> -->
            <el-row v-if="scope.row.name === 'WebsiteLoadError'"
              >错误码:{{ scope.row.data.code }}<br />错误次数：{{
                scope.row.data.times
              }}</el-row
            >
            <el-row v-else-if="scope.row.name === 'OpenSuccess'"
              >url打开成功：{{ scope.row.data.OpenSuccess }}</el-row
            >
            <el-row v-else-if="scope.row.name === 'OpenStarted'"
              >url开始加载：{{ scope.row.data.OpenStarted }}</el-row
            >
            <el-row v-else-if="scope.row.name === 'WebsiteSwitched'"
              >url从：{{ scope.row.data.fromWeb }} <br />切换到{{
                scope.row.data.toWeb
              }}</el-row
            >
            <el-row v-else-if="scope.row.name === 'WebViewClicked'"
              >x：{{ scope.row.data.x }} <br />y:{{ scope.row.data.y }}</el-row
            >
            <el-row v-else>
              <el-tooltip
                class="item"
                effect="dark"
                style="width: 30%"
                :content="JSON.stringify(scope.row.data)"
                placement="left-start"
              >
                <span>{{ scope.row.data }}</span>
              </el-tooltip>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="事件发生时间">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row.id, scope.row.customerName, scope.row.name)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-row>

    <el-dialog title="添加事件名称" :visible.sync="dialogFormVisible">
      <el-form :model="form" size="mini">
        <el-form-item label="事件名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="事件描述" :label-width="formLabelWidth">
          <el-input v-model="form.description" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sureAddEventName" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn.js";
export default {
  data() {
    return {
      total: 0,
      loading: false,
      currentPage: 1,
      tableData: [],
      searchForm: {
        appName: "",
        customerName: "",
        start: "",
        end: "",
        name: "",
        currentPage: 1,
        pageSize: 50,
        channel: "",
        label: "",
        deviceId: "",
      },
      pageSize: 50,
      options: [
        // {value:'OpenStarted',label:'开始加载'},//开始加载
        // {value:'OpenSuccess',label:'加载成功'},//加载成功
        // {value:'WebViewClicked',label:'点击事件'},//点击事件
        // {value:'UserStayTimeInMillisecond',label:'webView存在时长'},//webview存在时长
        // {value:'WebsiteSwitched',label:'website url切换'},//url切换
        // {value:'SessionTimeInMillisecond',label:'website存在时长'},//website存在时长
        // {value:'TotalWebsitesInSession',label:'浏览网站总数'},//Session里展示过的网站总数
        // {value:'WebsiteLoadError',label:'website错误'},//website错误事件，对应错误列表详见飞书
        // {value:'AppEventStart',label:'APP进入启动页'},
        // {value:'AppEventDone',label:'APP进入首页'},
        // {value:'AppEventVideoPageStart',label:'APP进入详情页'},
      ],
      form: {
        name: "",
        description: "",
      },
      dialogFormVisible: false,
      formLabelWidth: "100px",
    };
  },
  methods: {
    search() {
      this.pageSize = 50;
      this.currentPage = 1;
      this.searchForm.currentPage = 1;
      this.searchForm.pageSize = 50;
      this.getEventList(this.searchForm);
    },
    handleDelete(id, custom, name) {
      console.log(id);
      this.$confirm(`此操作将永久删除${custom}下的这条${name}的记录, 是否继续?`, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axiosPost("/api/event/delete", { ids: [id] }, "JSON").then((res) => {
            if (res.code == 0) {
              this.$message({ message: "该记录已删除", type: "success" });
              this.getEventList(this.searchForm);
            }
          });
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.searchForm.currentPage = this.currentPage;
      this.searchForm.pageSize = val;
      this.getEventList(this.searchForm);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchForm.currentPage = val;
      this.searchForm.pageSize = this.pageSize;
      this.getEventList(this.searchForm);
    },
    async getEventList(params) {
      this.loading = true;
      let request = {
        currentPage: params.currentPage,
        pageSize: params.pageSize,
        customerName: params.customerName || "",
        start: params.start || "",
        name: params.name || "",
        appName: params.appName || "",
        end: params.end || "",
        channel: params.channel || "",
        deviceId: params.deviceId || "",
        label: params.label || "",
      };
      const res = await axiosGet("/api/event/list", request);
      this.loading = false;
      if (res.code == 0) {
        this.tableData = res.data.records;
        this.total = res.data.total;
      }
    },
    async getEventNameList() {
      const res = await axiosGet("/api/event/name/list");
      if (res.code == 0) {
        if (res.data.length) {
          this.options = res.data;
        }
      }
    },
    handleAdd() {
      this.dialogFormVisible = true;
      this.form = {
        name: "",
        description: "",
      };
    },
    sureAddEventName() {
      if (!this.form.name || !this.form.description) {
        this.$message({ message: "所有字段均为必填项", type: "error" });
        return false;
      }
      axiosPost("/api/event/name/add", this.form, "JSON").then((res) => {
        if (res.code == 0) {
          this.$message({ message: "添加成功", type: "success" });
          this.dialogFormVisible = false;
          this.getEventNameList();
        }
      });
    },
  },
  mounted() {
    this.getEventList({ currentPage: 1, pageSize: 50 });
    this.getEventNameList();
  },
};
</script>

<style>
.el-table .cell {
  /* max-height: 60px; */
  /* max-height: 60px; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 设置最多显示的行数 */
  white-space: normal; /* 允许文本换行 */
}
.el-tooltip__popper {
  max-width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/view/eventList.vue